
import {CALL_API} from '../../middleware/api';

export const UPDATE_NEED_PERSON_REQUEST = 'UPDATE_NEED_PERSON_REQUEST'
export const UPDATE_NEED_PERSON_SUCCESS = 'UPDATE_NEED_PERSON_SUCCESS'
export const UPDATE_NEED_PERSON_FAILURE = 'UPDATE_NEED_PERSON_FAILURE'

export function updateNeedPerson(params) {
	return {
		[CALL_API]: {
			types: [UPDATE_NEED_PERSON_REQUEST, UPDATE_NEED_PERSON_SUCCESS, UPDATE_NEED_PERSON_FAILURE],
      endpoint: `workflow/recruitment/update-need-person`,
      params
		}
	}
}

export default (params) => {
	return (dispatch, getState) => {
		return dispatch(updateNeedPerson(params))
	}
}


// WEBPACK FOOTER //
// ./src/action/recruitment/updateNeedPerson.js